import { CircularProgress, Fade, Stack, Typography, useTheme } from '@mui/material';

import i18n from '~lib/i18n';
import { Dimens } from '~themes';

interface GeneralLoaderProps {
	title?: string;
	visible?: boolean;
}

const GeneralLoader = ({
	title = i18n.t('loading', { ns: 'status' }),
	visible = true,
}: GeneralLoaderProps) => {
	const theme = useTheme();

	return (
		<Fade
			in={visible}
			appear
			timeout={{ enter: 200, exit: 150 }}
			mountOnEnter
			unmountOnExit={false}
		>
			<Stack
				direction='column'
				spacing={Dimens.spacing2xl}
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Typography variant='heading2xl'>{title}</Typography>
				<CircularProgress sx={{ color: theme.palette.bgBrandSolid.main }} />
			</Stack>
		</Fade>
	);
};

export default GeneralLoader;
